
import btnPrimary from '~/components/common/buttons/btn-primary'
export default {
  components: {
    btnPrimary,
  },
  layout: 'error',
  props: {
    error: {
      type: [String, Object],
      default: () => ({}),
    },
  },
  data() {
    return {
      content: {},
      seo: {},
    }
  },
  async fetch() {
    this.$store.commit('isLoading', true)
    const data = await this.$store.dispatch('apis/get404Page')
    this.content = data.content
    this.seo = data.seo
    this.$store.commit('isLoading', false)
  },
  head() {
    return this.$getMetaTags(this.seo)
  },
  mounted() {
    console.error(this.error)
  },
}
